<template>
    <v-card
        class="pa-4 prompt-card"
        :color="(color ? color : '#ef5350')"
        dark
        :href="target"
        :target="(target ? '_blank' : '')"
        :to="route"
    >
        <div class="d-flex">
            <div>
                <div
                    v-if="subtitle"
                    class="prompt-subtitle"
                    :style="getStyleObject(this.textSize.subtitle)"
                >
                    {{ subtitle }}
                </div>
                <div
                    v-if="title"
                    class="prompt-title"
                    :style="getStyleObject(this.textSize.title)"
                >
                    {{ title }}
                </div>
            </div>
            <v-spacer />
            <v-icon :size="this.textSize.icon + 'rem'">
                {{ icon }}
            </v-icon>
        </div>
    </v-card>
</template>

<script>
export default {
    props: {
        title: String,
        subtitle: String,
        icon: String,
        color: String,
        target: String,
        route: String
    },
    computed: {
        textSize: function() {
            let defaultSizes = {
                title: 2.25,
                subtitle: 1.325,
                icon: 2.5
            }

            switch (this.$vuetify.breakpoint.name) {
            case 'xs': 
                return {
                    title: 1.75,
                    subtitle: 1.125,
                    icon: 2
                };
            case 'sm': 
                return {
                    title: 2,
                    subtitle: 1.125,
                    icon: 3
                };
            case 'md': 
                return {
                    title: 1.825,
                    subtitle: 1,
                    icon: 2
                };
            case 'lg': 
                return {
                    title: 2.125,
                    subtitle: 1.25,
                    icon: 2.5
                };
            default: return defaultSizes;
            }
        }
    },
    methods: {
        getStyleObject(size) {
            return {
                fontSize : size + "rem",
                lineHeight: size + 0.5 + "rem"
            }
        }
    }
}
</script>

<style lang="scss">
.prompt-title {
  font-weight: 400;
  line-height: 2.5rem;
  letter-spacing: 0.0073529412em;
  font-family: "Roboto", sans-serif !important;
}

.prompt-subtitle {
  font-weight: 300;
  line-height: 2rem;
  letter-spacing: 0.0073529412em;
  font-family: "Roboto", sans-serif !important;
}
</style>